import Head from 'next/head'
import { FC } from 'react'
import config from 'utils/siteConfig'

interface ImageMetaProps {
  image?: string
  twitterImage?: string
  ogImage?: string
}

const ImageMeta: FC<ImageMetaProps> = ({ image, twitterImage, ogImage }) => {
  const specificTwitterImage = ogImage || image || twitterImage
  const specificOpenGraphImage = twitterImage || image || ogImage

  const actualTwitterImage = specificTwitterImage || config.shareImage
  const actualOpenGraphImage = specificOpenGraphImage || config.shareImage

  return (
    <Head>
      {/* Same keys as GeoHead: a page with both heads keeps one of each */}
      <meta key="twitter:card" name="twitter:card" content="summary_large_image" />
      <meta key="twitter:image" name="twitter:image" content={actualTwitterImage} />
      <meta key="og:image" property="og:image" content={actualOpenGraphImage} />
      {!specificOpenGraphImage && (
        <>
          <meta property="og:image:width" content={config.shareImageWidth.toString()} />
          <meta property="og:image:height" content={config.shareImageHeight.toString()} />
        </>
      )}
    </Head>
  )
}

export default ImageMeta
